<template>
  <div>
    <v-row class="selectableItemArea pa-0 ma-0" justify="center">
      <v-col cols="12" lg="12" v-for="(item , i ) in items" :key="i" class="pa-0 ma-0" style="cursor: pointer">
        <div class="selectableItem  d-flex flex-column justify-space-around" :id="item.id" @click="setRadioSelected(item.id)"
             :class="radioSelected == item.id && 'activeOption'">
          <div class="textSelectBox">
            <template v-if="$vuetify.rtl">
              {{ item.text }}
            </template>
            <template v-else>
              {{ item.en_text }}
            </template>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-btn class="confirmBtn mt-5" block id="confirm_btn" color="#3CBE8B" elevation="0" @click="changes" v-if="$vuetify.breakpoint.lgAndUp">
      {{$t('matchMaking.buttons.submit') }}
    </v-btn>
  </div>
</template>

<script>

export default {
  props: {
    language: {
      default: 'fa'
    },
    items: Array,
    callChangeInOption: Boolean,
  },
  data() {
    return {
      radioSelected: null,
    }
  },
  methods: {
    setRadioSelected(id) {
      this.radioSelected = id
    },
    changes() {
      if (this.radioSelected) {
        this.$emit('answerHandler', [
          {
            'question_option_id': this.radioSelected,
          },
        ])
      } else {
        this.$emitEvent('notify', {color: 'red', title: this.$t('matchMaking.pleaseAnswer')});
      }
    }
  },
  watch: {
    callChangeInOption(val) {
      if (val) {
        this.changes()
      }
    }
  }
}

</script>

<style scoped>
@media (min-width: 200px) and (max-width: 800px) {
  .selectableItem {
    min-height: 100px !important;
  }
}

.selectableItemArea {
  min-height: 66px;

}

.selectableItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 2px solid transparent;
  box-shadow: inset 0 0 0 1px #E1E1E1;
  background: #FFF;
  transition: all 0.3s;
  cursor: pointer;
  text-align: center;
  margin-bottom: 16px;
}

.activeArea {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #4576d8;
}

.activeItem {
  border: 3px solid #4576d8;
}

.numeriArea {
  width: 70%;
  margin: auto;
}

.textSelectBox {
  line-height: 20pt;
  display: flex;
  height: 60px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  transition: all 0.3s;
  cursor: pointer;
}

.selectableItem:hover {
  transition: all 0.3s;
  border-color: #39C990 !important;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.activeOption {
  border: 2px solid #39C990;
  box-shadow: none;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}
</style>
